import getMessages from 'messages';
import _ from 'lodash';

const supportedLocales = [
  'en', 'fr'
];

class Internationalization {
  __messages;
  locale;

  init(locale = 'en') {
    this.locale = locale;
  }

  get messages() {
    if (!this.__messages) {
      this.__messages = getMessages(this.locale);
    }

    return this.__messages;
  }
}

const singleton = new Internationalization();

export default singleton;
